import type {
  IngredientFilter,
  IngredientFilterV2,
} from "@shared/components/CatalogSearch/CatalogSearch";

import { useCatalogSearch } from "../useCatalogSearch/useCatalogSearch";

const useIngredientRemove = () => {
  const { excludedIngredients, setExcludedIngredients, activeIngredients, setActiveIngredients } =
    useCatalogSearch();

  const removeIngredient = (ingredientToRemove: IngredientFilter, isExcludedIngredient = false) => {
    const arrayToRemoveElementFrom: IngredientFilterV2[] = isExcludedIngredient
      ? excludedIngredients
      : activeIngredients;

    const newArrayWithoutIngredient = arrayToRemoveElementFrom.filter(
      ingredient => ingredient.name !== ingredientToRemove.name
    );

    isExcludedIngredient
      ? setExcludedIngredients(newArrayWithoutIngredient)
      : setActiveIngredients(newArrayWithoutIngredient);
  };

  return { removeIngredient };
};

export { useIngredientRemove };
